import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import axios from "axios";
import * as Sentry from "@sentry/browser";

import router from "@/router";

const state = {
  logged: !!window.localStorage.getItem("_token"),
  rememberMe: window.localStorage.getItem("_remember") || false,
  userType: window.localStorage.getItem("_userType"),
  nombreUsuario: "",
  rgpd: "",
  token: "",
  hasPracticas: false,
  tieneCVadjunto: null,
  clickPopUpRecordatoriaCVAdjunto: false,
  hasEmpleo: false,
  godMode: window.localStorage.getItem("godMode") || false,
  soloCiclosUAX: window.localStorage.getItem("_soloCiclosUAX") == "true",
  listaEmpresas: "",
  logindata: "",
  isPrimerAcceso:
    Boolean(window.localStorage.getItem("_primerAcceso")) || false,
  loggedby: window.localStorage.getItem("loggedby"),
  clickPopUpDocumentacionEmpresa: false,
  clickPopUpDocumentacionAlumno:
    Boolean(window.localStorage.getItem("PopupDocumentacionAlumno")) || false,
  pedirNAF: false,
  faltaDatoDeseaRecibirInformacionUni:null
};

const getters = {
  getLogged: state => state.logged,
  getRememberMe: state => state.rememberMe,
  getUserType: state => state.userType,
  isEmpresa: state => state.userType == "Empresa",
  isAlumno: state => state.userType == "Alumno",
  getUserName: state => state.nombreUsuario,
  getTextoRGPD: state => state.rgpd,
  hasPracticas: state => state.hasPracticas,
  hasEmpleo: state => state.hasEmpleo,
  getGodmodeStatus: state => Boolean(state.godMode),
  getListaEmpresas: state => state.listaEmpresas,
  getlogindata: state => state.logindata,
  getloggedby: state => state.loggedby,
  getPrimerAcceso: state => state.isPrimerAcceso,
  getsoloCiclosUAX: state => state.soloCiclosUAX,
  alumnotype: state => (state.hasPracticas ? "UTP" : "UTE"),
  getTieneCVadjunto: state => state.tieneCVadjunto,
  getClickPopupCVadjunto: state => state.clickPopUpRecordatoriaCVAdjunto,
  getClickPopUpDocumentacionEmpresa: state =>
    state.clickPopUpDocumentacionEmpresa,
  getClickPopUpDocumentacionAlumno: state =>
    state.clickPopUpDocumentacionAlumno,
  getPedirNAF: state => state.pedirNAF,
  getFaltaDatoDeseaRecibirInformacionUni: state => state.faltaDatoDeseaRecibirInformacionUni
};
const actions = {
  login: ({ commit, dispatch }, user) => {
    let type = user.eAmbito == "PrivadoEmpresa" ? "Empresa" : "Alumno";
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/${type}/logaUsuario`, user)
        .then(response => {
          resolve(response.data.status == 0);

          if (response.data.status == 0) {
            let data = {
              response: response,
              type: type,
              user: user.eUsuario
            };

            dispatch("loggedThings", data);

            window.localStorage.setItem("loggedby", "server");
          } else {
            // Códigos en los que mostramos el mensaje explicativo que devuelve el servidor
            let customCodes = [3, 79, 107];

            if (
              customCodes.includes(response.data.status) &&
              !!response.data.mensaje
            ) {
              commit("setErrorMensaje", response.data);
            } else {
              commit("setCompleteError", response);
            }

            resolve(false);
          }
        })
        .catch(function (error) {
          commit("setError", 500);
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  loginSAML: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post("api/Alumno/validaRespuestaLoginIntegrado", { respuesta: data })
        .then(response => {
          let data = {
            response: response,
            type: "Alumno"
          };

          dispatch("loggedThings", data);

          window.localStorage.setItem("loggedby", "saml");
        })
        .catch(function (error) {
          commit("setError", 500);
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  loginSAMLEmpresas: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post("api/Empresa/validaRespuestaLoginIntegrado", { respuesta: data })
        .then(response => {
          let data = {
            response: response,
            type: "Empresa"
          };

          dispatch("loggedThings", data);

          window.localStorage.setItem("loggedby", "saml");
        })
        .catch(function (error) {
          commit("setError", 500);
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  dameEmpresasUsuario: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post("api/Empresa/dameEmpresasDelUsuario", data)
        .then(response => {
          let fullresponse = response;
          response = response.data;

          if (response.status == 0) {
            commit("savePass", data);

            if (response.datos.length > 1) {
              commit("setListaEmpresas", response.datos);
            } else {
              dispatch("sendEmpresaSeleccionada", response.datos[0].idEmpresa);
            }
          } else {
            commit("setCompleteError", fullresponse);
          }
        })
        .catch(function (error) {
          commit("setError", 500);
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  sendEmpresaSeleccionada: ({ commit, dispatch }, idEmpresa) => {
    let user = state.logindata;

    user.eidEmpresa = idEmpresa;

    let type = user.eAmbito == "PrivadoEmpresa" ? "Empresa" : "Alumno";

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/Empresa/logaUsuario`, user)
        .then(response => {
          let data = {
            response: response,
            type: type,
            user: user.eUsuario
          };
          commit("removedataEmpresa");

          dispatch("loggedThings", data);
        })
        .catch(function (error) {
          commit("setError", 500);
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  loggedThings: ({ commit, dispatch, getters }, data) => {
    let response = data.response.data;
    let fullresponse = data.response;
    let type = data.type;
    
    if (response.status == 0) {
      let token = response.datos.token;

      window.localStorage.setItem("_userType", type);
      window.localStorage.setItem(
        "faltaConvenioFirmado",
        response.datos.faltaConvenioFirmado
      );
      window.localStorage.setItem(
        "tieneCVadjunto",
        response.datos.tieneCVadjunto
      );
      if (!!response.datos.textoCortoRGPD) {
        let dataRGPD = {
          text: response.datos.textoCortoRGPD,
          link: response.datos.linkExternoRGPD
        };

        commit("setRGPD", dataRGPD);

        type == "Empresa" ? commit("setEmpresa") : null;

        window.sessionStorage.setItem("_tokenRGPD", token);
        window.localStorage.setItem(
          "_hasPracticas",
          response.datos.conPracticas
        );
        window.localStorage.setItem("_hasEmpleo", response.datos.conEmpleo);
        window.localStorage.setItem(
          "_primerAcceso",
          response.datos.primerAcceso
        );
        window.localStorage.setItem(
          "_soloCiclosUAX",
          response.datos.soloCiclosUAX
        );
      } else {
        window.localStorage.setItem("_token", token);
        window.localStorage.setItem(
          "_hasPracticas",
          response.datos.conPracticas
        );
        window.localStorage.setItem("_hasEmpleo", response.datos.conEmpleo);
        window.localStorage.setItem(
          "_primerAcceso",
          response.datos.primerAcceso
        );
        window.localStorage.setItem(
          "_soloCiclosUAX",
          response.datos.soloCiclosUAX
        );
        setTimeout(() => {
          window.localStorage.setItem("PopupDocumentacionAlumno", false);
        }, "1000");

        axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

        if (response.datos.idIdiomaPreferido) {
          window.localStorage.setItem(
            "_idIdiomaPreferido",
            response.datos.idIdiomaPreferido
          );
          dispatch("changeLanguage", response.datos.idIdiomaPreferido);
        }
        
        commit("setUser");
        dispatch("requestAllData");
        commit("setNombreUsuario");

        if (!!window.sessionStorage.getItem("prelogin")) {
          router.push(window.sessionStorage.getItem("prelogin"));
          window.sessionStorage.removeItem("prelogin");
        } else {
          router.push("/");
        }
        commit("setLoading", false);
      }
    } else {
      // Códigos en los que mostramos el mensaje explicativo que devuelve el servidor
      let customCodes = [3, 79, 90];

      if (customCodes.includes(response.status) && !!response.mensaje) {
        commit("setErrorMensaje", response);
      } else {
        commit("setCompleteError", fullresponse);
      }

      // Si el login no es correcto no vienen datos, salimos para no pisar el error
      return;
    }
    if (type == "Empresa") {
      state.faltaDatoDeseaRecibirInformacionUni = data.response.data.datos.faltaDatoDeseaRecibirInformacionUni;
      window.localStorage.setItem("faltaDatoDeseaRecibirInformacionUni",  data.response.data.datos.faltaDatoDeseaRecibirInformacionUni);
      window.localStorage.setItem("PopupDocumentacionEmpresa", false);
      commit("setPedirNAF", false);
    } else {
      if (data.response.data.datos.faltaNumeroSeguridadSocial == true) {
        commit("setPedirNAF", true);
        // dispatch("requestEncuestas", 'alumno');
      } else {
        commit("setPedirNAF", false);
      }
    }
  },
  checkTokenExpiration: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      let token = window.localStorage.getItem("_token");
      if (!!token) {
        const jwtDecode = require("jwt-decode");
        let data = jwtDecode(token);
        let now = Math.round(new Date().getTime() / 1000);
        if (now > data.exp) {
          window.localStorage.removeItem("_token");
          window.localStorage.removeItem("_userType");
          reject("sesion finalizada");
        } else {
          resolve(true);
        }
      } else {
        commit("setError", 2);
      }

      commit("setUser");
    });
  },
  logout: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      window.localStorage.removeItem("_token");
      window.localStorage.removeItem("_hasPracticas");
      window.localStorage.removeItem("_hasEmpleo");
      window.localStorage.removeItem("_userType");
      window.localStorage.removeItem("_primerAcceso");
      window.localStorage.removeItem("_idIdiomaPreferido");
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.localStorage.setItem("cookie:accepted", true);
      commit("setLogged", false);
      resolve(true);
    });
  },
  requestPass: ({ commit, dispatch }, cif) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/Empresa/recuerdoPassword", { cif: cif })
        .then(response => {
          response.data.status == 0
            ? resolve(true)
            : commit("setCompleteError", response);
        })
        .catch(function (error) {
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  changeRemember: ({ commit, dispatch }, value) => {
    commit("toggleRemember");
  },
  requestAllData: ({ dispatch, getters, commit }) => {
    if (getters.getInMantenimiento & !!!getters.getGodmodeStatus) {
      dispatch("logout");
    } else {
      dispatch("requestComunicaciones", getters.getUserType);
      dispatch("requestNotificaciones");

      if (getters.isAlumno) {
        dispatch("requestParamsOfertas");
        dispatch("requestCandidaturas");
        dispatch("requestTitulaciones");
        dispatch("requestMotivosRechazo");
        dispatch("requestPracticasEnValidacion");
        if (getters.getBrand.checkDatosNecesariosEnLogin) {
          dispatch("requestDatosNecesariosEnLogin");
        }
        if (getters.getBrand.popupDatosObligatorios) {
          dispatch("checkDatosPersonalesObligatorios");
        }

        if (getters.getBrand.checkIbanInPracticasConServicio) {
          dispatch("checkIbanInPracticasConServicio");
        }

        if (getters.getBrand.hasProgramaPracticasActivo) {
          dispatch("requestProgramasPracticas");
        }

        if (getters.getPrimerAcceso) {
          window.localStorage.removeItem("_primerAcceso");
        }
        dispatch("requestAnexosAlumno");
      }

      if (getters.isEmpresa) {
        dispatch("createAniosForo");
        dispatch("requestAnexos");
        if (getters.getBrand.hasProgramaPracticasActivo) {
          dispatch("requestProgramasPracticasEmpresa");
          dispatch("requestProgramasPracticas");
        }

        if (getters.getBrand.checkDatosCompletosEmpresa) {
          dispatch("checkFaltanDatosContacto");
          dispatch("checkFaltanDatosEmpresa");
        }
        if (getters.getBrand.checkMenuEducacion) {
          dispatch("checkMenuEducacion");
        }
      }

      dispatch("requestDominios");

      commit("setNombreUsuario");

      commit("setUser");
    }
  },
  requestRGPD: () => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/Alumno/dameTextoRGPDactual")
        .then(response => {
          response.data.status == 0
            ? resolve(response.data.datos)
            : commit("setCompleteError", response);
        })
        .catch(function (error) {
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },
  guardarRGPD: ({ commit, dispatch, getters }, isEmpresa) => {
    return new Promise((resolve, reject) => {
      let token = window.sessionStorage.getItem("_tokenRGPD");

      let type = isEmpresa ? "Empresa" : "Alumno";

      axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

      axios
        .get(`/api/${type}/guardaAceptacionRGPD`)
        .then(response => {
          if (response.data.status == 0) {
            let token = window.sessionStorage.getItem("_tokenRGPD");
            window.sessionStorage.removeItem("_tokenRGPD");

            window.localStorage.setItem("_token", token);

            axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

            commit("setUser");

            dispatch("requestAllData");
            commit("setNombreUsuario");
            commit("eraseTextRGPD");

            resolve(true);
          } else {
            commit("setCompleteError", response);
          }
        })
        .catch(function (error) {
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  },

  erasePedirNAF: function ({ commit }) {
    commit("setPedirNAF", false);
  },
  truePedirNAF: function ({ commit }) {
    commit("setPedirNAF", true);
  },
  setPopupDocumentacionTrue: function ({ commit }) {
    commit("setPopupDocumentacion", true);
  },
  setPopupDocumentacionFalse: function ({ commit }) {
    commit("setPopupDocumentacion", false);
  },
  activarGodMode: function ({ commit }) {
    commit("setGodmode", true);
  },
  desactivarGodMode: function ({ commit }) {
    commit("setGodmode", false);
  },
  requestDatosNecesariosEnLogin: ({ commit, dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/Alumno/faltaDatosNecesariosPorPractica")
        .then(response => {
          if (response.data.status == 0) {
            if (response.data.datos) {
              dispatch("sendErrorServer", 518);
            }
          }
        })
        .catch(function (error) {
          reject(false);
          dispatch("sendErrorServer", error.response);
        });
    });
  }
};

const mutations = {
  setUser(state) {
    if (!!window.localStorage.getItem("_token")) {
      const token = window.localStorage.getItem("_token");

      const jwtDecode = require("jwt-decode");

      axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

      let user = jwtDecode(token);

      state.logged = true;

      state.userType = window.localStorage.getItem("_userType");

      state.isPrimerAcceso =
        window.localStorage.getItem("_primerAcceso") != "false";

      state.hasPracticas =
        window.localStorage.getItem("_hasPracticas") != "false";

      state.hasEmpleo = window.localStorage.getItem("_hasEmpleo") != "false";
      state.tieneCVadjunto =
        window.localStorage.getItem("tieneCVadjunto") != "false";
    } else {
      state.logged = false;
      state.userType = "";
      router.push("/login");
    }
  },
  setLogged(state, logged) {
    state.logged = logged;
  },
  setEmpresa(state) {
    state.isEmpresa = true;
  },
  setClickPopupRecordatorioCvAdjunto(state) {
    state.clickPopUpRecordatoriaCVAdjunto = true;
  },
  setTieneCVadjuntoUpload(state) {
    state.tieneCVadjunto = true;
    window.localStorage.setItem("tieneCVadjunto", true);
  },
  setListaEmpresas(state, empresas) {
    state.listaEmpresas = empresas;
  },
  toggleRemember() {
    state.rememberMe = !state.rememberMe;
    window.localStorage.setItem("_remember", state.rememberMe);
  },
  setNombreUsuario(state) {
    if (!!window.localStorage.getItem("_token")) {
      const token = window.localStorage.getItem("_token");
      const jwtDecode = require("jwt-decode");
      let user = jwtDecode(token);
      if (!!!window.sessionStorage.getItem("name")) {
        state.nombreUsuario = `${user.unique_name} ${user.family_name}`;
      } else {
        state.nombreUsuario = window.sessionStorage.getItem("name");
      }

      Sentry.setUser({ name: state.nombreUsuario });
    }
  },
  setNombreUsuarioCambiado(state, data) {
    state.nombreUsuario = data;
    window.sessionStorage.setItem("name", data);
  },
  setRGPD(state, data) {
    state.rgpd = data;
  },
  eraseTextRGPD(state) {
    state.rgpd = null;
  },
  setGodmode(state, status) {
    if (status) {
      window.localStorage.setItem("godMode", true);
      state.godMode = true;
    } else {
      window.localStorage.removeItem("godMode");
      state.godMode = false;
    }
  },
  savePass(state, data) {
    state.logindata = data;
  },
  removedataEmpresa(state) {
    state.logindata = "";
    state.listaEmpresas = "";
  },
  setPedirNAF(state, data) {
    setTimeout(() => {
      state.pedirNAF = data;
    }, "1000");
  },
  setPopupDocumentacion(state, data) {
    setTimeout(() => {
      state.clickPopUpDocumentacionAlumno = data;
    }, "1000");
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/auth.js